import styled from "@emotion/styled";

import { FONT_WEIGHT_BOLD } from "../utilities";

export const FieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;

  border: 0;
  margin: 0;
  padding: 0;
`;

export const FieldSetLegend = styled.legend`
  position: relative;

  width: 100%;

  top: 8px;

  padding-top: 8px;

  font-weight: ${FONT_WEIGHT_BOLD};
  font-size: ${({ theme }) => theme.fontSize};
  line-height: 1rem;

  color: ${({ theme }) => theme.generalTextIcon};
`;
